function initialState () {
  return {
    previousRoute: {}
  };
}

const state = initialState();

const getters = {};

const actions = {
  updatePreviousRoute({ commit }, route) {
    commit('updateState', {
      prop: 'previousRoute',
      value: route
    });
  }
};

const mutations = {
  updateState (state, { prop, value }) {
    state[prop] = value;
  },
  resetState (state) {
    Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
